import React, {useState} from 'react';
import {Button, Input, message, Modal, Space, Steps} from 'antd';
import {Auth} from "@aws-amplify/auth";
import {useNavigate} from "react-router";

const {Step} = Steps;

// Helper function for constant-time string equality to prevent timing attacks
const constantTimeEquals = (a, b) => {
    if (a.length !== b.length) {
        return false;
    }
    let result = 0;
    for (let i = 0; i < a.length; i++) {
        result |= a.charCodeAt(i) ^ b.charCodeAt(i);
    }
    return result === 0;
};


const ForgotPassword = (props) => {
    const [isModalVisible, setIsModalVisible] = useState(props.reset);
    const [userName, setUserName] = useState('');
    const [currentStep, setCurrentStep] = useState(props.step ? props.step : 0);
    const [code, setCode] = useState(props.code);
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const navigate = useNavigate();

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleOk = () => {
        if (currentStep === 0) {
            if (userName === '') {
                message.warning("Please enter your email!");
            } else {
                Auth.forgotPassword(userName).then((res) => {
                        setCurrentStep(1);
                    }
                ).catch((err) => {
                    message.error(err.message);
                });
            }
        } else if (currentStep === 1 || currentStep === "1") {
            if (userName === '') {
                message.warning("Please enter your email!");
            }
            else if (code === '') {
                message.warning("Please enter code!");
            } else {
                const isPasswordEmpty = !password;
                const isConfirmPasswordEmpty = confirmPassword.length === 0;
                if (isPasswordEmpty || isConfirmPasswordEmpty ) {
                    message.warning("Please enter new password and confirm it!");
                } else if (!constantTimeEquals(password, confirmPassword)) {
                    message.warning("Passwords don't match!");
                } else {
                    Auth.forgotPasswordSubmit(
                        userName,
                        code,
                        password
                    ).then((res) => {
                        message.success("Password reset successfully.");
                        navigate("/login");
                        setIsModalVisible(false);
                    }).catch((err) => {
                        message.error(err.message);
                    });
                }
            }
        }
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    return (
        <>

            <Button size="small" type="link" onClick={showModal}>
                Forgot Password?
            </Button>
            <Modal title="Password Recovery" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
                <Steps current={currentStep}>
                    <Step title="Get code"/>
                    <Step title="Reset Password"/>
                </Steps>
                {currentStep === 0 && (
                    <div style={{marginTop: 20}}>
                        <Input placeholder="Enter your email to get a reset code" value={userName}
                               onChange={(e) => setUserName(e.target.value)}/>
                    </div>
                )}
                {currentStep === 1 && (
                    <div style={{marginTop: 20}}>
                        <Space direction="vertical" style={{width: '100%'}}>
                            <Input placeholder="Enter your email" value={userName}
                                   onChange={(e) => setUserName(e.target.value)}/>
                            <Input placeholder="Enter code received in your email" value={code}
                                   onChange={(e) => setCode(e.target.value)}/>
                            <Input.Password placeholder="New Password" value={password}
                                            onChange={(e) => setPassword(e.target.value)}/>
                            <Input.Password placeholder="Confirm Password" value={confirmPassword}
                                            onChange={(e) => setConfirmPassword(e.target.value)}/>
                        </Space>

                    </div>
                )}

            </Modal>
        </>
    );
};

export default ForgotPassword;